"use client";

import React from "react";

//Styles
import * as S from "./styles";
import { ChevronLeft } from "lucide-react";

const ButtonArround = () => {
  return (
    <S.Button>
      <ChevronLeft />
    </S.Button>
  );
};

export default ButtonArround;
